import React from 'react';
import { IconProps } from './types';

export const Calendar = ({ className, title }: IconProps) => (
  <svg
    id="Calender_Icon"
    data-name="Calender Icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    className={className}
    viewBox="0 0 18 18"
  >
    <title>{title}</title>
    <g
      id="Rectangle"
      transform="translate(0 3)"
      fill="#fff"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="1"
    >
      <rect width="18" height="15" stroke="none" />
      <rect x="0.5" y="0.5" width="17" height="14" fill="none" />
    </g>
    <path
      id="Line"
      d="M.5,3V.5"
      transform="translate(4)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="1"
    />
    <path
      id="Line-2"
      data-name="Line"
      d="M.5,3V.5"
      transform="translate(13)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="1"
    />
    <rect
      id="Rectangle-2"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(5 6)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-3"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(9 6)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-4"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(13 6)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-5"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(9 10)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-6"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(13 10)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-7"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(5 14)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-8"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(9 14)"
      fill="#0693ca"
    />
    <rect
      id="Rectangle-9"
      data-name="Rectangle"
      width="2"
      height="2"
      transform="translate(13 14)"
      fill="#0693ca"
    />
  </svg>
);
